export default __webpack_public_path__ + "assets/front/scss/classification-browsing.61693ace8ec2ecda80a61a8a7ca02c4d.css";